import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 224.94 220.36' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M101.69 83l1-17.17h122.3V47.35H103.67l.5-9L90.8 32.2C92.68 29 93 25.48 93 18.84 93 7.75 85.77 0 75.43 0S57.86 7.75 57.86 18.84c0 6.64.32 10.15 2.2 13.36l-13.37 6.2.5 9H0v18.48h48.22l1 17.17H55l5 32.93H0v18.52h55.74v17.24h39.38V134.5h39.32l1 17.17h5.86l5.56 36.52H142v32.17h39.38v-32.17h-4.86l5.48-36.52h5.86l1-17.17h36.08V116h-35l.5-9-13.44-6.18c1.88-3.21 2.2-6.72 2.2-13.36 0-11.09-7.22-18.84-17.57-18.84s-17.57 7.75-17.57 18.84c0 6.64.32 10.15 2.2 13.36L132.92 107l.5 9H90.81l5-32.93zm39.52 29l18.28-8.48-4-4c-2.84-2.84-3.35-3.35-3.35-12 0-6.69 3.67-10.84 9.57-10.84s9.57 4.15 9.57 10.84c0 8.66-.51 9.17-3.35 12l-4 4L182.1 112l-.22 4-.14 2.5-.14 2.5-.47 8.52L181 132l-.14 2.5-.51 9.17h-5.16l-8 52.52h6.17v16.17H150v-16.17h6.17l-8-52.52H143l-.51-9.17-.14-2.5-.14-2.5-.51-8.5-.14-2.5-.14-2.5zm78.73 17.5h-30.8l.47-8.52h30.32zm-85.77 0H5V121h128.69zm-47 14.24H63.74v-9.24h23.38zM68.14 116l-6.23-41h-5.17l-.51-9.17-.14-2.5-.09-2.45-.47-8.52-.14-2.5-.14-2.5-.22-4 18.24-8.46-4-4c-2.84-2.84-3.35-3.35-3.35-12C65.86 12.15 69.53 8 75.43 8S85 12.15 85 18.84c0 8.66-.51 9.17-3.35 12l-4 4 18.28 8.48-.22 4-.14 2.5-.14 2.5-.47 8.52-.14 2.5-.14 2.5-.56 9.16H89l-6.28 41zM5 60.88v-8.53h42.47l.47 8.52zm214.94 0h-117l.47-8.52h116.53z'
        />
        <path
          className='cls-1'
          d='M111.48 162.06a21.64 21.64 0 1 0 21.64 21.64 21.66 21.66 0 0 0-21.64-21.64zM97.85 183.7a13.64 13.64 0 1 1 13.64 13.64 13.65 13.65 0 0 1-13.64-13.64z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CalcioBalillaIcon.js